import { createContext, useContext } from "react";

import { type ProfileResponse } from "@vega-api/generated/types/profileResponse";

export type SessionContextInterface = {
  clearUser: () => void;
  setUserData: (data: ProfileResponse) => void;
  user: ProfileResponse | null;
};

export const SessionContext = createContext<SessionContextInterface | null>(
  null,
);

export function useSession() {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }

  return context;
}
